module.exports = __webpack_public_path__ + "media/customizations/default/spinner-primary-0b7040bf4dd7b350afc56090309e2d50.gif";